import React from "react";

export const InputComponent = (props) => {
  return <input {...props.formControl} className="form-control" />;
};
